import React from 'react';
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import * as yup from "yup";

import * as api from "../../services/api";
import {useFeedbackTools} from "../../components/FeedbackTools";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoadingButton from "@mui/lab/LoadingButton";


const validationSchema = yup.object().shape({
    email: yup
        .string()
        .email("Deve essere un'email")
        .required('Campo obbligatorio'),
});

const PasswordResetPage = () => {
    let navigate = useNavigate();
    const {showErrorNotification} = useFeedbackTools();
    const [isLoading, setIsLoading] = React.useState(false);
    const [requestSent, setRequestSent] = React.useState(false);

    const formik = useFormik({
        initialValues: {
            email: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true);
            const {email} = values;
            try {
                await api.Authentication.resetPasswordRequest(email);
                setRequestSent(true)
            } catch (e) {
                showErrorNotification(e);
            }
            setIsLoading(false);
        },
    });

    const handleClickHomepage = (e) => {
        e.preventDefault();
        navigate("/")
    };

    const disableSave = Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <React.Fragment>
            {
                requestSent ? (
                    <Box>
                        <Typography>
                            Ti abbiamo inviato un'email con le istruzioni per recuperare la password all'indirizzo:
                        </Typography>

                        <Typography component="div">
                            <Box sx={{my: 2, textAlign: 'center', fontWeight: 'bold'}}>
                                {formik.values.email}
                            </Box>
                        </Typography>

                        <Typography>
                            Per continuare controlla la tua casella di posta e segui le istruzioni indicate nell'email.
                        </Typography>

                        <Box mt={5} textAlign="left" fontWeight="bold">
                            ATTENZIONE
                        </Box>

                        <Typography>
                            Per ragioni di sicurezza, non inoltrare l'email con le istruzioni per recuperare
                            la password e non comunicare i dati in essa contenuti a nessuno.
                            <Box component="u" mx={1}>Nemmeno se ti viene espressamente chiesto di farlo!</Box>
                        </Typography>

                        <Button fullWidth
                                variant="contained"
                                sx={{mt: 5, mb: 2}}
                                onClick={handleClickHomepage}>
                            Homepage
                        </Button>
                    </Box>
                ) : (
                    <Box component="form"
                         noValidate
                         onSubmit={formik.handleSubmit}
                         sx={{mt: 1, width: "100%"}}>

                        <Typography gutterBottom>
                            Per recuperare la password è necessario inserire l'indirizzo email con cui sei registrato
                        </Typography>

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Indirizzo email"
                            name="email"
                            autoComplete="username"
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}/>

                        <LoadingButton
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={disableSave}
                            sx={{my: 3}}
                            loading={isLoading}>
                            Avanti
                        </LoadingButton>

                        <Box textAlign="center">
                            <Link href="#" onClick={handleClickHomepage}>
                                Homepage
                            </Link>
                        </Box>
                    </Box>
                )
            }
        </React.Fragment>
    );
};

export default PasswordResetPage;